export default {
  generateGraphRequestFromUser(user) {
    if (user && user.extSysApiUserId) {
      return {
        id: user.extSysApiUserId,
        method: "GET",
        url: `/users/${user.extSysApiUserId}/photos/48x48/$value`
      };
    }
  }
};
